import { Maximize2, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { rosaryUI } from "@/data/rosaryLocale";

export const MysteryArtwork = ({ mystery, lang }) => {
  const { art } = mystery;
  const t = rosaryUI(lang);
  return (
    <figure className="mb-8 min-w-0" data-testid="mystery-artwork">
      <Dialog>
        <DialogTrigger asChild>
          <button type="button" className="group relative block aspect-[4/3] w-full overflow-hidden bg-paleblue/30" data-testid="mystery-artwork-expand" aria-label={`${t.expandArt} — ${mystery.title}`}>
            <img src={art.src} alt={`${mystery.title} — ${art.artist}`} className="h-full w-full object-contain" data-testid="mystery-artwork-image" />
            <span className="absolute bottom-3 right-3 rounded-full bg-white/90 p-2 text-midnight transition-colors group-hover:bg-white"><Maximize2 size={16} /></span>
          </button>
        </DialogTrigger>
        <DialogContent className="w-[calc(100%-2rem)] max-w-4xl border-gold/25 bg-ivory p-4 sm:p-6" data-testid="mystery-artwork-modal">
          <DialogTitle className="pr-8 font-serif text-xl" data-testid="mystery-artwork-modal-title">{mystery.title}</DialogTitle>
          <DialogDescription className="text-xs" data-testid="mystery-artwork-modal-description">{art.artist} · {art.year}</DialogDescription>
          <img src={art.src} alt={mystery.title} className="max-h-[65vh] w-full object-contain" data-testid="mystery-artwork-modal-image" />
        </DialogContent>
      </Dialog>
      <figcaption className="mt-2 flex flex-wrap items-baseline justify-between gap-2 text-[11px] leading-relaxed text-slateblue" data-testid="mystery-artwork-credit">
        <span>{art.artist} · {art.year}</span>
        <a href={art.source} target="_blank" rel="noopener noreferrer" data-testid="mystery-artwork-source" className="inline-flex items-center gap-1 transition-colors hover:text-gold">{t.artSource}<ExternalLink size={11} /></a>
      </figcaption>
    </figure>
  );
};